import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { api } from "@/lib/api";

const POLL_MS = 30000;

export function NewPostsPill({ since, onShow, anchorId }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    setCount(0);
    if (!since) return;
    const check = () => { if (document.visibilityState === "visible") api.get("/feed/new-count", { params: { since } }).then(({ data }) => setCount(data.count)).catch(() => {}); };
    const t = setInterval(check, POLL_MS);
    document.addEventListener("visibilitychange", check);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", check); };
  }, [since]);
  if (!count) return null;
  const show = () => {
    setCount(0);
    onShow();
    const el = document.getElementById(anchorId);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: "smooth" });
  };
  return (
    <div className="fixed inset-x-0 top-[calc(env(safe-area-inset-top)+4rem)] lg:top-24 z-40 flex justify-center pointer-events-none">
      <button onClick={show} data-testid="feed-new-posts-btn"
        className="pointer-events-auto fade-up inline-flex items-center gap-1.5 px-4 h-10 rounded-full pink-gradient text-white text-sm font-bold shadow-lg shadow-rose-300/50 active:scale-95 transition-transform">
        <ArrowUp className="w-4 h-4" /> {count === 1 ? "1 neuer Beitrag" : `${count > 99 ? "99+" : count} neue Beiträge`}
      </button>
    </div>
  );
}
